// extracted by mini-css-extract-plugin
module.exports = {"wr":"PremiumArticleTags_wr__2GLd-","card":"PremiumArticleTags_card__T9cdY","form":"PremiumArticleTags_form__19Q9O","btnContainer":"PremiumArticleTags_btnContainer__12OUd"};